import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import user from './user';
import signup from './signup';

export default combineReducers({ user, signup, form: formReducer });



// WEBPACK FOOTER //
// ./src/reducers/index.js